import {Route} from 'router5';
import {Role} from 'stores/UserStore';

export type RouteName =
  'login'
  | 'register'
  | 'dashboard'
  | 'landing'
  | 'landing.about'
  | 'landing.blog'
  | 'landing.feedback'
  | 'landing.faq'
  | 'courses'
  | 'courses.create'
  | 'courses.course.edit'
  | 'lessons'
  | 'lessons.create'
  | 'webinars'
  | 'webinars.create'
  | 'webinars.webinar.view'
  | 'tasks.create'
  | string
;

export default [
  {
    name: 'landing',
    path: '/',
    children: [
      {
        name: 'about',
        path: 'about'
      },
      // {
      //   name: 'blog',
      //   path: 'blog'
      // },
      {
        name: 'feedback',
        path: 'feedback'
      },
      {
        name: 'faq',
        path: 'faq'
      },
    ]
  },
  {
    name: 'login',
    path: '/login',
  },
  {
    name: 'register',
    path: '/register?role',
    defaultParams: {
      role: Role.Student,
    },
  },
  {
    name: 'teachers',
    path: '/teachers',
    children: [
      {
        name: 'teacher',
        path: '/:teacherName',
        children: [
          {
            name: 'courses',
            path: '/courses',
            children: [
              {
                name: 'course',
                path: '/:slug',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: 'dashboard',
    path: '/dashboard',
  },
  {
    name: 'tariffs',
    path: '/tariffs',
  },
  {
    name: 'courses',
    path: '/courses',
    children: [
      {
        name: 'create',
        path: '/create?tab',
        defaultParams: {
          tab: 'settings',
        },
      },
      {
        name: 'course',
        path: '/:id',
        children: [
          {
            name: 'edit',
            path: '/edit?tab',
            defaultParams: {
              tab: 'settings',
            },
          },
          {
            name: 'program',
            path: '/program',
          },
        ],
      },
    ],
  },
  {
    name: 'lessons',
    path: '/lessons',
    children: [
      {
        name: 'create',
        path: '/create',
      },
      {
        name: 'lesson',
        path: '/:id',
        children: [
          {
            name: 'edit',
            path: '/edit',
          },
        ],
      },
    ],
  },
  {
    name: 'webinars',
    path: '/webinars',
    children: [
      {
        name: 'create',
        path: '/create',
      },
      {
        name: 'webinar',
        path: '/:id',
        children: [
          {
            name: 'view',
            path: '/view',
          },
          {
            name: 'edit',
            path: '/edit',
          },
        ],
      },
    ],
  },
  {
    name: 'library',
    path: '/library?tab',
    defaultParams: {
      tab: 'all',
    },
  },
  {
    name: 'settings',
    path: '/settings',
  },
  {
    name: 'tasks',
    path: '/tasks',
    children: [
      {
        name: 'create',
        path: '/create?tab',
        defaultParams: {
          tab: 'content',
        },
      },
      {
        name: 'task',
        path: '/:id',
        children: [
          {
            name: 'edit',
            path: '/edit',
          },
          {
            name: 'view',
            path: '/view',
          },
          {
            name: 'progress',
            path: '/progress',
          },
        ],
      },
    ],
  },
  {
    name: 'payments',
    path: '/payments',
  },
  {
    name: 'students',
    path: '/students',
    children: [
      {
        name: 'student',
        path: '/:studentId',
      },
    ],
  },
  {
    name: 'logout',
    path: '/logout'
  },
  {
    name: 'recipes',
    path: '/recipes',
    children: [
      {
        name: 'create',
        path: '/create',
      },
      {
        name: 'recipe',
        path: '/:recipeId',
        children: [
          {
            name: 'view',
            path: '/view',
          },
          {
            name: 'edit',
            path: '/edit',
          },
        ],
      },
    ],
  },
  {
    name: 'ingredients',
    path: '/ingredients',
    children: [
      {
        name: 'create',
        path: '/create',
      },
    ],
  },
  {
    name: 'trainings',
    path: '/trainings',
    children: [
      {
        name: 'create',
        path: '/create',
      },
      {
        name: 'training',
        path: '/:trainingId',
        children: [
          {
            name: 'view',
            path: '/view',
          },
          {
            name: 'edit',
            path: '/edit',
          },
        ],
      },
    ],
  },
  {
    name: 'exercises',
    path: '/exercises',
    children: [
      {
        name: 'create',
        path: '/create',
      },
      {
        name: 'exercise',
        path: '/:exerciseId',
        children: [
          {
            name: 'edit',
            path: '/edit',
          },
        ],
      },
    ],
  },
  {
    name: 'foods',
    path: '/foods',
    children: [
      {
        name: 'create',
        path: '/create',
      },
      {
        name: 'food',
        path: '/:foodId',
        children: [
          {
            name: 'view',
            path: '/view',
          },
          {
            name: 'edit',
            path: '/edit',
          },
        ],
      },
    ],
  },
] as Route[];
